import { useEffect, useState } from 'react'
import { ProfileImport } from './Import'
const { Form, FormikProvider, useFormik, Text, TextArea, SelectBox, DatePicker, Number, Email, File, SaveButton, UpdateProfileSchema, useNavigate, useDispatch, useSelector, districtList, updateProfile, Loader, debounce, addUpdateHandler, toggleUpdateModal, toggleBool, useTranslation } = ProfileImport

export default function UpdateProfileForm() {

    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)
    const [districtLoading, setDistrictLoading] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const details = useSelector(state => state?.profileDetails?.data)
    const district = useSelector(state => state?.districtList?.data)
    // console.log(details)

    const district_option = district?.map(val => (
        { "value": val.id, "label": val.district_name }
    ))

    const gender_option = [
        { "value": 'male', "label": 'Male' },
        { "value": 'female', "label": 'Female' },
        { "value": 'other', "label": 'Other' },
    ]

    const initialValues = {
        id: details?.userInfo?.id,
        first_name: details?.user_first_name,
        last_name: details?.user_last_name,
        gender: details?.userInfo?.gender,
        dob: details?.userInfo?.date_of_birth,
        email: details?.userInfo?.user_email,
        mobile_number: details?.userInfo?.user_mobile,
        profile: '',
        district: details?.userInfo?.districtInfo?.id,
        address: details?.userInfo?.address,
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: UpdateProfileSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("value", values)
            setSpinner(true)
            dispatch(updateProfile({ 'values': values })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: `${t('profile.profile')} ${t('common.success_update')}`,
                wrong_toast: `${t('common.wrong')}`,
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => {
                    dispatch(toggleUpdateModal());
                    dispatch(toggleBool());
                }
            }))
        },
    })

    const load_district = debounce((e) => {
        const pageable = { search: e };
        if (e) {
            setDistrictLoading(true)
            dispatch(districtList({ pageable, navigate, status: 'Active' })).finally(() => setDistrictLoading(false))
        }
    }, 500)

    useEffect(() => {

        const district_name = details?.userInfo?.districtInfo?.district_name;
        const pageable = { search: district_name }
        Promise.all([
            dispatch(districtList({ pageable, navigate, status: 'Active' })),
        ]).finally(() => setLoading(false));

    }, [])

    return (
        <>
            <div className="container-fluid">
                {loading ?
                    <div className="row">
                        <div className="col-md-12">
                            <Loader />
                        </div>
                    </div>
                    :
                    <FormikProvider value={formik}>
                        <Form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>
                            <div className="row">

                                <div className="col-md-3">
                                    <Text
                                        label_name={t('profile.fname')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='first_name'
                                        value={formik.values.first_name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.first_name && formik.touched.first_name ? (<span className='field_error'>{formik.errors.first_name}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <Text
                                        label_name={t('profile.lname')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='last_name'
                                        value={formik.values.last_name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.last_name && formik.touched.last_name ? (<span className='field_error'>{formik.errors.last_name}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <SelectBox
                                        label_name={t('profile.gender')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        option={gender_option}
                                        name='gender'
                                        value={formik.values.gender}
                                        onChange={(e) =>
                                            formik.setFieldValue('gender', e)
                                        }
                                        onBlur={() => formik.setFieldTouched("gender", true)}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        error={formik.errors.gender && formik.touched.gender ? (<span className='field_error'>{formik.errors.gender}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <DatePicker
                                        label_name={t('profile.dob')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='dob'
                                        value={formik.values.dob || ''}
                                        onChange={(date, dateString) =>
                                            formik.setFieldValue('dob', dateString)
                                        }
                                        onBlur={() => formik.setFieldTouched("dob", true)}
                                        error={formik.errors.dob && formik.touched.dob ? (<span className='field_error'>{formik.errors.dob}</span>) : null}
                                    />
                                </div>

                                <div className='col-md-4'>
                                    <Number
                                        label_name={t('profile.mobile')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='mobile_number'
                                        value={formik.values.mobile_number}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.mobile_number && formik.touched.mobile_number ? (<span className='field_error'>{formik.errors.mobile_number}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <Email
                                        label_name={t('profile.email')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        name='email'
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.email && formik.touched.email ? (<span className='field_error'>{formik.errors.email}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <File
                                        label_name={t('profile.profile')}
                                        mandatory={false}
                                        disabled={false}
                                        name='profile'
                                        onChange={(e) =>
                                            formik.setFieldValue('profile', e.currentTarget.files[0])
                                        }
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.profile && formik.touched.profile ? (<span className='field_error'>{formik.errors.profile}</span>) : null}
                                        accept="image/jpg, image/jpeg, image/png"
                                    />
                                </div>

                                <div className="col-md-5">
                                    <SelectBox
                                        label_name={t('profile.district')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        option={district_option}
                                        name='district'
                                        value={formik.values.district}
                                        onChange={(e) =>
                                            formik.setFieldValue('district', e)
                                        }
                                        onInputChange={(e) => load_district(e)}
                                        onBlur={() => formik.setFieldTouched("district", true)}
                                        loading={districtLoading}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        error={formik.errors.district && formik.touched.district ? (<span className='field_error'>{formik.errors.district}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-7">
                                    <TextArea
                                        label_name={t('profile.address')}
                                        mandatory={true}
                                        placeholder=''
                                        disabled={false}
                                        rows={1}
                                        name='address'
                                        value={formik.values.address}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.errors.address && formik.touched.address ? (<span className='field_error'>{formik.errors.address}</span>) : null}
                                    />
                                </div>

                                <div className="col-md-12">
                                    <div className="d-flex justify-content-end">
                                        <div className="col-lg-4">
                                            <SaveButton
                                                button_name={t('common.submit')}
                                                spinner={spinner}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Form>
                    </FormikProvider>
                }
            </div>
        </>
    )
}
